module.exports = __webpack_public_path__ + "static/media/name.4003565a.svg";